import React from "react";

// Local Libraries
import phrasebookLoad from "../../../i18n";
import { gisRoutes } from "../../../routes/routes";


import * as token from "../../../helpers/token";
import { accountTypesConstants, portalFunctionalityConstants } from "../../../constants";
import { serviceNumberTypeInfoDetails } from '../ServiceNumberType/serviceNumberTypeForm';


import { initialState, updateState, summaryOrderDetails, summaryRequirements, summaryNumberFeature, summaryCharges, orderStatus } from './orderInput';


//Redux
import {
  orderActions
} from "actions";

//Components
import { NewBreadcrumbs } from "../../../components/SkyFramework/Breadcrumbs/NewBreadcrumbs";
import { ProgressTab } from "../../../components/SkyFramework/ProgressTab/ProgressTab";
import { CancelButton } from "../../../components/SkyFramework/Buttons"


import { connect } from "react-redux";

// Constants
const phrasebook = phrasebookLoad();

class Ordering extends React.Component {
  constructor(props) {
    super(props);

    this.state = initialState(token.loggedProperty('customer_id'), this.props.match.params.id);

    this.account_type_logged = accountTypesConstants[token.loggedAccountType()];

  }

  componentDidMount() {
    if (this.props.match.params.id)
      this.props.dispatch(orderActions.get(this.props.match.params.id));
  }

  componentDidUpdate(prevProps) {

    if (this.props.order && prevProps && prevProps.order !== this.props.order) {
      this.setState(updateState(this.props.order));
    }
  }

  render() {
    if (this.state.order) {
      return (
        <>
          <NewBreadcrumbs crumbs={[{ link: gisRoutes.dashboard[this.account_type_logged], label: phrasebook.common.home }, { link: gisRoutes.management.order.list, label: phrasebook.headerlinks.orders }]} current={`${phrasebook.orders.order_details}`} />
          <form class="box p-1 p-sm-2 p-lg-3">
            <div class="container-xs p-0">
              <h2 class="box-title pb-1 mb-1">{phrasebook.headerlinks.order}</h2>

              <div class="section-block mt-2">
                <div class="d-flex mb-2">
                  <h3 class="mb-0 mr-h"><strong>{phrasebook.orders.order_details}</strong></h3>
                </div>
                {summaryOrderDetails(phrasebook, this.state)}
              </div>
              <hr class="dotted my-3" />

              {serviceNumberTypeInfoDetails(phrasebook, this.state.selectedTypeNumber)}
              <hr class="dotted my-3" />

              {summaryRequirements(phrasebook, this.state)}


              <hr class="dotted my-3" />
              {summaryCharges(this.state)}
              {orderStatus(this.state)}

            </div>
            <div class="box-actions-footer mt-4"><CancelButton
              link={gisRoutes.management.order.list} title={phrasebook.orders.back_to_orders} /></div>
          </form>


          {/* {summaryButtons(this.state, loggedAccount, handleSubmit, prevStep, saveChanges)} */}
        </>
      );
    } else return null

  }
}

function mapStateToProps(state) {
  const {
    loggedpermissions,
    authentication,
    order,
  } = state;
  const { authUser } = authentication;
  return {
    authUser,
    loggedpermissions,
    order: order.order,
  };
}

const ordering = connect(mapStateToProps)(Ordering);
export default ordering;
